import { createSelector } from 'reselect';

export const getLegalEntitiesFromState = (state) => state.getIn(['entities', 'legalEntities', 'entities']);

// Returns all legal entities
export const getLegalEntities = createSelector(
  [getLegalEntitiesFromState, (state, props = {}) => props?.search],
  (legalEntities, search) => {
    if (!search) {
      return legalEntities;
    }

    return legalEntities.filter((entity) => {
      return (
        entity.get('chiefName') +
          entity.get('fill') +
          entity.get('organizationName') +
          entity.get('phone') +
          entity
            .get('email')
            .toLowerCase()
            ?.indexOf(search.toLowerCase()) !==
        -1
      );
    });
  },
);

// Return legal entity by id
export const getLegalEntityById = (state, props = {}) =>
  state.getIn(['entities', 'legalEntities', 'entities', props.entityId]);
